module.exports = __webpack_public_path__ + "img/Hat_fancy_sm.9c9aa752.svg";